import React from "react";
import { Users, ShieldCheck, Building2, Target, Clock } from "lucide-react";
import { C, Pill, StatCard } from "./shared";

export default function SuccessMetrics() {
  return (
    <section className="border-y" style={{ background: C.paper, borderColor: C.rule }}>
      <div className="max-w-7xl mx-auto px-6 py-16 md:py-20">
        <div className="text-center max-w-2xl mx-auto">
          <Pill color={C.purple}>Success metrics</Pill>
          <h2 className="font-display font-black text-3xl md:text-5xl mt-3 tracking-tight" style={{ color: C.navyDeep }}>
            Outcomes you can measure.
          </h2>
        </div>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-5 gap-4">
          <StatCard icon={Users}        value={10000} suffix="+"  label="Active Students"    color={C.green}  delay={0} />
          <StatCard icon={ShieldCheck}  value={2500}  suffix="+"  label="Verified Skills"    color={C.navy}   delay={100} />
          <StatCard icon={Building2}    value={200}   suffix="+"  label="Top Companies"      color={C.orange} delay={200} />
          <StatCard icon={Target}       value={40}    suffix="%+" label="Profile Completion" color={C.purple} delay={300} />
          <StatCard icon={Clock}        value={72}    prefix="< " suffix=" hrs" label="Avg Shortlist Time" color={C.green} delay={400} />
        </div>
      </div>
    </section>
  );
}
